import { zfUtils } from "./zf_utils";
export class zfct {
    static hasTableTargets() {
        return ($(".zfct-table-swipe").length > 0 ||
            $(".zfct-select-product-inner").length > 0 ||
            $(".zfct-column-table-image .zfct-image img").length > 0);
    }
    static prefetchIfPresent() {
        if (!zfct.hasTableTargets() || zfct.dataTablesPrefetchScheduled)
            return;
        zfct.dataTablesPrefetchScheduled = true;
        const prefetch = function () {
            zfct.ensureDataTablesLoaded();
        };
        const requestIdle = window.requestIdleCallback;
        if (typeof requestIdle === "function")
            requestIdle(prefetch);
        else
            setTimeout(prefetch, 0);
    }
    static ensureDataTablesLoaded() {
        if (zfct.dataTablesReady)
            return Promise.resolve(true);
        if (zfct.dataTablesLoadPromise)
            return zfct.dataTablesLoadPromise;
        zfct.dataTablesLoadPromise = Promise.all([
            import("datatables.net-dt"),
            import("datatables.net-responsive-dt"),
        ])
            .then(function () {
            zfct.dataTablesReady = true;
            return true;
        })
            .catch(function () {
            zfct.dataTablesLoadPromise = undefined;
            return false;
        });
        return zfct.dataTablesLoadPromise;
    }
    static initTables() {
        if (!zfct.hasTableTargets())
            return;
        zfct.ensureDataTablesLoaded().then(function (isLoaded) {
            if (!isLoaded)
                return;
            try {
                $(".zfct-table-swipe").each(function () {
                    var currentTable = $(this).attr("id");
                    if (!currentTable)
                        return;
                    var activeColumns = $("#" + currentTable)
                        .parent()
                        .data("active-cols")
                        ? $("#" + currentTable)
                            .parent()
                            .data("active-cols")
                        : 4;
                    var isMobile = ($(window).width() || 0) <= 720 ? true : false;
                    var adjustment = ($(window).width() || 0) < 720 || activeColumns == 1
                        ? 0
                        : activeColumns - 2;
                    var singleHeaderMultiColumn = $("#" + currentTable).find("th").length == 1 &&
                        $("#" + currentTable).find("tbody tr:first-child > td").length > 1
                        ? true
                        : false;
                    $.fn.dataTable.ext.errMode = "none";
                    $("#" + currentTable).off("error.dt").on("error.dt", function (e, settings, techNote, message) {
                        console.log("An error has been reported by DataTables: ", message);
                    });
                    if ((isMobile == false &&
                        $("#" + currentTable).find("th:not(.zfct-placeholder-header)")
                            .length <= activeColumns) ||
                        (isMobile == true &&
                            $("#" + currentTable).find("th:not(.zfct-placeholder-header)")
                                .length <= 2) ||
                        ($("#" + currentTable).find("th:not(.zfct-placeholder-header)")
                            .length == 1 &&
                            parseInt($("#" + currentTable)
                                .find("th:first-child")
                                .attr("colspan") || "0") >= activeColumns)) {
                        $("#" + currentTable)
                            .parent()
                            .find("> .zfct-table-swipe-controls")
                            .addClass("zfct-table-swipe-arrows-disabled");
                    }
                    if (singleHeaderMultiColumn == false) {
                        var table = $("#" + currentTable).DataTable({
                            autoWidth: false,
                            fixedColumns: {
                                left: 1,
                            },
                            info: false,
                            ordering: false,
                            paging: false,
                            responsive: true,
                            searching: false,
                            stateSave: false,
                            tabIndex: -1,
                        });
                        $("#" + currentTable)
                            .find("tbody td:first-child")
                            .hasClass("dt-empty")
                            ? $("#" + currentTable)
                                .find("tbody")
                                .addClass("zfct-table-body-hide")
                            : null;
                        var colList = table.columns().visible();
                        var firstTrue;
                        if (activeColumns != 1) {
                            for (var idx = 0; idx < colList.length; idx++) {
                                if (colList[idx] == true && firstTrue == null && idx != 0) {
                                    firstTrue = idx;
                                }
                                if (idx > activeColumns - 1) {
                                    table.column(idx).visible(false);
                                }
                            }
                        }
                        else {
                            for (var idx = 0; idx < colList.length; idx++) {
                                if (colList[idx] == true && firstTrue == null) {
                                    firstTrue = idx;
                                }
                                if (idx > activeColumns - 1) {
                                    table.column(idx).visible(false);
                                }
                            }
                        }
                        if (typeof firstTrue === "number") {
                            setNewVisible(firstTrue, firstTrue + adjustment, colList, activeColumns);
                        }
                        var initialX = null;
                        function startTouch(e) {
                            initialX = e.touches[0].clientX;
                        }
                        function moveTouch(e) {
                            if (initialX === null) {
                                return;
                            }
                            var currentX = e.touches[0].clientX;
                            var diffX = initialX - currentX;
                            if (diffX > 0) {
                                $("#swipe_rightbutton_" + currentTable).click();
                            }
                            else {
                                $("#swipe_leftbutton_" + currentTable).click();
                            }
                            initialX = null;
                            e.preventDefault();
                        }
                        var container = document.querySelector("#" + currentTable);
                        if (container) {
                            if (container.zfctStartTouch) {
                                container.removeEventListener("touchstart", container.zfctStartTouch, false);
                            }
                            if (container.zfctMoveTouch) {
                                container.removeEventListener("touchmove", container.zfctMoveTouch, false);
                            }
                            container.zfctStartTouch = startTouch;
                            container.zfctMoveTouch = moveTouch;
                            container.addEventListener("touchstart", startTouch, false);
                            container.addEventListener("touchmove", moveTouch, false);
                        }
                        if (zfct.tableResizeKeys[currentTable] !== undefined &&
                            zfct.tableResizeKeys[currentTable] !== null) {
                            zfUtils.offResize(zfct.tableResizeKeys[currentTable]);
                        }
                        zfct.tableResizeKeys[currentTable] = zfUtils.onResize(function () {
                            var colList = table.columns().visible();
                            var activeColumns = $("#" + currentTable)
                                .closest(".zfct-table")
                                .data("active-cols")
                                ? $("#" + currentTable)
                                    .closest(".zfct-table")
                                    .data("active-cols")
                                : 4;
                            var firstTrue;
                            var swipeContainer = $("#" + currentTable)
                                .closest(".zfct-table")
                                .find("> .zfct-table-swipe-controls");
                            var countTrue = 0;
                            if (($(window).width() || 0) < 720) {
                                if (activeColumns != 1) {
                                    for (var idx = 0; idx < colList.length; idx++) {
                                        if (colList[idx] == true && firstTrue == null && idx != 0) {
                                            firstTrue = idx;
                                            setNewVisible(firstTrue, firstTrue, colList, activeColumns);
                                        }
                                    }
                                }
                                else {
                                    for (var idx = 0; idx < colList.length; idx++) {
                                        if (colList[idx] == true && firstTrue == null) {
                                            firstTrue = idx;
                                            setNewVisible(firstTrue, firstTrue, colList, activeColumns);
                                        }
                                    }
                                }
                            }
                            else {
                                if (activeColumns != 1) {
                                    for (var idx = 0; idx < colList.length; idx++) {
                                        if (colList[idx] == true && firstTrue == null && idx != 0) {
                                            firstTrue = idx;
                                            if (firstTrue + (activeColumns - 2) > colList.length) {
                                                setNewVisible(firstTrue, firstTrue, colList, activeColumns);
                                            }
                                            else {
                                                setNewVisible(firstTrue - (activeColumns - 2), firstTrue, colList, activeColumns);
                                            }
                                        }
                                    }
                                }
                                else {
                                    for (var idx = 0; idx < colList.length; idx++) {
                                        if (colList[idx] == true && firstTrue == null) {
                                            firstTrue = idx;
                                            setNewVisible(firstTrue, firstTrue, colList, activeColumns);
                                        }
                                    }
                                }
                            }
                            for (var idx = 0; idx < colList.length; idx++) {
                                if (colList[idx] == true) {
                                    countTrue++;
                                }
                            }
                            if ((countTrue <= activeColumns && activeColumns == colList.length) ||
                                ($("#" + currentTable).find("th:not(.zfct-placeholder-header)").length == 1 &&
                                    parseInt($("#" + currentTable)
                                        .find("th:first-child")
                                        .attr("colspan") || "0") >= activeColumns &&
                                    activeColumns != 1)) {
                                !swipeContainer.hasClass("zfct-table-swipe-arrows-disabled")
                                    ? swipeContainer.addClass("zfct-table-swipe-arrows-disabled")
                                    : null;
                            }
                            else {
                                swipeContainer.removeClass("zfct-table-swipe-arrows-disabled");
                            }
                        });
                        $("#swipe_leftbutton_" + currentTable)
                            .off("click.zfct")
                            .on("click.zfct", function () {
                            var colList = table.columns().visible();
                            var activeColumns = $("#" + currentTable)
                                .closest(".zfct-table")
                                .data("active-cols")
                                ? $("#" + currentTable)
                                    .closest(".zfct-table")
                                    .data("active-cols")
                                : 4;
                            var firstTrue;
                            if (colList[1] != true && activeColumns != 1) {
                                for (var idx = 0; idx < colList.length; idx++) {
                                    if (colList[idx] == true && firstTrue == null && idx != 0) {
                                        firstTrue = idx;
                                    }
                                }
                                var adjustment = ($(window).width() || 0) < 720 ? 0 : activeColumns - 2;
                                if (typeof firstTrue !== "number")
                                    return;
                                var slidePrevFirst = firstTrue - 1;
                                var slidePrevLast = firstTrue + adjustment - 1;
                                setNewVisible(slidePrevFirst, slidePrevLast, colList, activeColumns);
                            }
                            else if (colList[0] != true && activeColumns == 1) {
                                for (var idx = 0; idx < colList.length; idx++) {
                                    if (colList[idx] == true && firstTrue == null) {
                                        firstTrue = idx;
                                    }
                                }
                                if (typeof firstTrue !== "number")
                                    return;
                                var slidePrevFirst = firstTrue - 1;
                                setNewVisible(slidePrevFirst, slidePrevFirst, colList, activeColumns);
                            }
                        });
                        $("#swipe_rightbutton_" + currentTable)
                            .off("click.zfct")
                            .on("click.zfct", function () {
                            var colList = table.columns().visible();
                            var activeColumns = $("#" + currentTable)
                                .closest(".zfct-table")
                                .data("active-cols")
                                ? $("#" + currentTable)
                                    .closest(".zfct-table")
                                    .data("active-cols")
                                : 4;
                            var firstTrue;
                            if (colList[colList.length - 1] != true) {
                                if (activeColumns != 1) {
                                    for (var idx = 0; idx < colList.length; idx++) {
                                        if (colList[idx] == true &&
                                            firstTrue == null &&
                                            idx != 0) {
                                            firstTrue = idx;
                                        }
                                    }
                                    var adjustment = ($(window).width() || 0) < 720 ? 0 : activeColumns - 2;
                                    if (typeof firstTrue !== "number")
                                        return;
                                    var slideNextFirst = firstTrue + 1;
                                    var slideNextLast = firstTrue + adjustment + 1;
                                    setNewVisible(slideNextFirst, slideNextLast, colList, activeColumns);
                                }
                                else if (activeColumns == 1) {
                                    for (var idx = 0; idx < colList.length; idx++) {
                                        if (colList[idx] == true && firstTrue == null) {
                                            firstTrue = idx;
                                        }
                                    }
                                    if (typeof firstTrue !== "number")
                                        return;
                                    var slideNextFirst = firstTrue + 1;
                                    setNewVisible(slideNextFirst, slideNextFirst, colList, activeColumns);
                                }
                            }
                        });
                        function setNewVisible(firstTrue, lastTrue, colList, activeCols) {
                            if (firstTrue == lastTrue && activeCols == 1) {
                                for (var idx = 0; idx < colList.length; idx++) {
                                    if (idx == firstTrue) {
                                        table.column(idx).visible(true);
                                    }
                                    else {
                                        table.column(idx).visible(false);
                                    }
                                }
                                if (firstTrue == 0) {
                                    $("#swipe_leftbutton_" + currentTable).addClass("zfct-table-swipe-disabled");
                                    $("#swipe_rightbutton_" + currentTable).removeClass("zfct-table-swipe-disabled");
                                }
                                else if (lastTrue + 1 == colList.length) {
                                    $("#swipe_leftbutton_" + currentTable).removeClass("zfct-table-swipe-disabled");
                                    $("#swipe_rightbutton_" + currentTable).addClass("zfct-table-swipe-disabled");
                                }
                                else {
                                    $("#swipe_leftbutton_" + currentTable).removeClass("zfct-table-swipe-disabled");
                                    $("#swipe_rightbutton_" + currentTable).removeClass("zfct-table-swipe-disabled");
                                }
                            }
                            else {
                                for (var idx = 0; idx < colList.length; idx++) {
                                    if ((idx >= firstTrue && idx <= lastTrue) || idx == 0) {
                                        table.column(idx).visible(true);
                                    }
                                    else {
                                        table.column(idx).visible(false);
                                    }
                                }
                                if (firstTrue - 1 == 0) {
                                    $("#swipe_leftbutton_" + currentTable).addClass("zfct-table-swipe-disabled");
                                    $("#swipe_rightbutton_" + currentTable).removeClass("zfct-table-swipe-disabled");
                                }
                                else if (lastTrue + 1 == colList.length) {
                                    $("#swipe_leftbutton_" + currentTable).removeClass("zfct-table-swipe-disabled");
                                    $("#swipe_rightbutton_" + currentTable).addClass("zfct-table-swipe-disabled");
                                }
                                else {
                                    $("#swipe_leftbutton_" + currentTable).removeClass("zfct-table-swipe-disabled");
                                    $("#swipe_rightbutton_" + currentTable).removeClass("zfct-table-swipe-disabled");
                                }
                            }
                        }
                    }
                    else {
                        $("#" + currentTable).addClass("zfct-table-horizontal-overflow");
                    }
                });
                $(".zfct-select-product-inner").each(function () {
                    $(this)
                        .off("change.zfct")
                        .on("change.zfct", function () {
                        if ($(this).val() != null) {
                            var product = $(this).val().toString();
                            var lastChar = product.match(/\d/g);
                            if (!lastChar || !lastChar.length)
                                return;
                            var linkedTable = $(this)
                                .parents(".zfct-select-product")
                                .siblings(".zfct-custom-table");
                            linkedTable.find("tbody tr td").removeClass("data-visible");
                            linkedTable
                                .find("tbody tr td:nth-child(" + lastChar.join("") + ")")
                                .addClass("data-visible");
                        }
                    })
                        .trigger("change");
                });
                $(".zfct-column-table-image .zfct-image img").each(function () {
                    var tblHeight = $(this).height() || 0;
                    $(this).css({ height: tblHeight, width: tblHeight * 2 });
                });
            }
            catch (err) {
                console.log("Initalization failed: zfct.init() " + err.message);
            }
        });
    }
}
zfct.dataTablesReady = false;
zfct.dataTablesPrefetchScheduled = false;
zfct.tableResizeKeys = {};
try {
    zfUtils.onReady(function () {
        zfct.prefetchIfPresent();
        zfct.initTables();
    });
}
catch (err) {
    console.log("Initalization failed: zfct.init() " + err.message);
}
